import BaseModel from '../BaseModel';
import InterviewPreset from './InterviewPreset';

export default class InterviewPresetCategory extends BaseModel {
  static entity = 'interviewPresetCategories';

  static primary = 'id';

  static fields() {
    return {
      id: this.attr(null),
      name: this.string(null),
      children: this.hasMany(InterviewPresetCategory, 'parentId', 'id'),
      parentId: this.attr(null),
      presets: this.attr(null),
      depth: this.number(0),
      presetsModels: this.hasManyBy(InterviewPreset, 'presets'),
    };
  }

  static apiConfig = {
    actions: {
      fetch() {
        this.get('interviews/presets/categories');
      },
    },
  }
}
